<template>
  <div>
    <page-header
      title="Pippeline Management"
      breadcrumb="CRM  > Pipeline Management"
    />

    <div class="container-fluid">
      <div class="row text-deepBlue">
        <div class="col-12 col-md-4 col-lg-3">
          <div class="card py-3 px-3 px-3 rounded">
            <div class="flex justify-center">
              <div>
                <img src="@/assets/images/icons/leads.svg" alt="leads icon" />
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue font-bold">Leads</p>
            </div>
            <div class="text-sm pt-2">
              <!-- <div class="flex justify-between">
                <p class="font-semibold">By Value</p>
                <p class="text-lightGrey">₦ 45</p>
              </div> -->
              <div class="flex justify-between pt-2 pb-4">
                <p class="font-semibold">Total Volume</p>
                <p class="text-lightGrey">{{ count.leadVolume }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <div class="card px-3 rounded py-3">
            <div class="flex justify-center">
              <div>
                <img
                  src="@/assets/images/icons/opportunities.svg"
                  alt="opportunity icon"
                />
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue font-bold">Opportunity</p>
            </div>
            <div class="text-sm pt-2">
              <div class="flex justify-between">
                <p class="font-semibold">By Value</p>
                <p class="text-lightGrey">₦ {{ count.opportunityValue }}</p>
              </div>
              <div class="flex justify-between pt-2">
                <p class="font-semibold">Total Volume</p>
                <p class="text-lightGrey">{{ count.opportunityVolume }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <div class="card px-3 rounded py-3">
            <div class="flex justify-center">
              <div>
                <img src="@/assets/images/icons/sales.svg" alt="sales icon" />
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue font-bold">Sales</p>
            </div>
            <div class="text-sm pt-2">
              <div class="flex justify-between">
                <p class="font-semibold">By Value</p>
                <p class="text-lightGrey">₦ {{ count.saleValue }}</p>
              </div>
              <div class="flex justify-between pt-2">
                <p class="font-semibold">Total Volume</p>
                <p class="text-lightGrey">{{ count.saleVolume }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-3">
          <div class="card px-3 rounded py-3">
            <div class="flex justify-center">
              <div>
                <img
                  src="@/assets/images/icons/total.svg"
                  alt="customer count icon"
                />
              </div>
            </div>
            <div class="pt-4">
              <p class="text-deepBlue font-bold">Total</p>
            </div>
            <div class="text-sm pt-2">
              <div class="flex justify-between">
                <p class="font-semibold">By Value</p>
                <p class="text-lightGrey">₦ {{ count.totalValue }}</p>
              </div>
              <div class="flex justify-between pt-2">
                <p class="font-semibold">Total Volume</p>
                <p class="text-lightGrey">{{ count.totalVolume }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex mt-12 mb-2">
      <div
        class="tab-item"
        :class="{ active: currentTab == 'leads' }"
        @click="currentTab = 'leads'"
      >
        <p>LEADS</p>
      </div>
      <div
        class="tab-item"
        :class="{ active: currentTab == 'opportunities' }"
        @click="currentTab = 'opportunities'"
      >
        <p>OPPORTUNITIES</p>
      </div>
      <div
        class="tab-item"
        :class="{ active: currentTab == 'sales' }"
        @click="currentTab = 'sales'"
      >
        <p>SALES</p>
      </div>
    </div>
    <hr />
    <keep-alive>
      <component :is="currentTab"></component>
    </keep-alive>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Leads from "./Tabs/Leads";
import Opportunities from "./Tabs/Opportunities";
import Sales from "./Tabs/Sales";

export default {
  components: {
    PageHeader,
    Leads,
    Opportunities,
    Sales,
  },
  data() {
    return {
      currentTab: "leads",
      count: {},
    };
  },
  mounted() {
    this.getCountsByCategory();
  },
  methods: {
    async getCountsByCategory() {
      try {
        const response = await this.$_getCountsByCategory();
        this.logResponse(response);
        this.count = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #10233e;
    font-weight: bold;
  }
}
</style>
